// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu-right {
  right: 0;
  left: auto;
  top: auto;
}

.header-navbar .navbar-container ul.nav li a.dropdown-user-link .user-name {
  margin-left: 0rem !important;
}

.border_bottom {
  border-bottom: none !important;
}

:host ::ng-deep .dropdown-item:active {
  color: #3f3000 !important;
  background-color: #ffd700 !important;
}

@media only screen and (max-width: 991.98px) {
  .ft-toggle-right {
    display: none !important;
  }

  .ft-toggle-left {
    display: none !important;
  }

  .collapse:not(.show) {
    display: unset !important;
  }
}

.header-navbar .navbar-header .navbar-brand .brand-text {
  padding-left: 11px !important;
  color: #4c3a00 !important;
  max-width: 170px;
  white-space: normal;
  line-height: 1.05;
  margin: 0;
}

.header-navbar .navbar-header .navbar-brand .brand-text .brand-line {
  display: block;
}

.header-navbar .navbar-header .navbar-brand .brand-logo {
  height: 44px !important;
  width: auto;
  object-fit: contain;
}

.header-navbar .navbar-header .navbar-nav {
  align-items: center;
}

.header-navbar .navbar-header .navbar-brand {
  display: flex;
  align-items: center;
  max-width: calc(100% - 52px);
  padding-right: 0.25rem;
}

.header-navbar .navbar-header .nav-toggle {
  flex: 0 0 auto;
  margin-left: 0 !important;
}

.header-navbar .navbar-header .nav-toggle .modern-nav-toggle {
  padding-left: 0.5rem !important;
  padding-right: 0.35rem !important;
}
.badge-up {
  top: 15px;
  right: 10px;
}

.notification-item {
  border-radius: 0.5rem;
  transition: background-color 0.3s ease;
 
  padding: 10px !important;
  margin-bottom: 5px;  
    border: 1px solid #ccc;
}
.notification-unread {
  background-color: #f0f8ff; /* light blue for unread */
  font-weight: 500;
}
.notification-read {
  background-color: #f8f9fa; /* light gray for read */
  color: #6c757d;
}
.notification-item:hover {
  background-color: #e9ecef;
}

.notifcation-list {
  overflow-y: auto;
  height: calc(100vh - 72px) !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/_layout/header/vertical/vertical.component.css"],"names":[],"mappings":"AAAA;EACE,QAAQ;EACR,UAAU;EACV,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;AACA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;;EAEtC,wBAAwB;EACxB,kBAAkB;IAChB,sBAAsB;AAC1B;AACA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,gBAAgB;AAClB;AACA;EACE,yBAAyB,EAAE,wBAAwB;EACnD,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC","sourcesContent":[".dropdown-menu-right {\n  right: 0;\n  left: auto;\n  top: auto;\n}\n\n.header-navbar .navbar-container ul.nav li a.dropdown-user-link .user-name {\n  margin-left: 0rem !important;\n}\n\n.border_bottom {\n  border-bottom: none !important;\n}\n\n:host ::ng-deep .dropdown-item:active {\n  color: #3f3000 !important;\n  background-color: #ffd700 !important;\n}\n\n@media only screen and (max-width: 991.98px) {\n  .ft-toggle-right {\n    display: none !important;\n  }\n\n  .ft-toggle-left {\n    display: none !important;\n  }\n\n  .collapse:not(.show) {\n    display: unset !important;\n  }\n}\n\n.header-navbar .navbar-header .navbar-brand .brand-text {\n  padding-left: 11px !important;\n  color: #4c3a00 !important;\n  max-width: 170px;\n  white-space: normal;\n  line-height: 1.05;\n  margin: 0;\n}\n\n.header-navbar .navbar-header .navbar-brand .brand-text .brand-line {\n  display: block;\n}\n\n.header-navbar .navbar-header .navbar-brand .brand-logo {\n  height: 44px !important;\n  width: auto;\n  object-fit: contain;\n}\n\n.header-navbar .navbar-header .navbar-nav {\n  align-items: center;\n}\n\n.header-navbar .navbar-header .navbar-brand {\n  display: flex;\n  align-items: center;\n  max-width: calc(100% - 52px);\n  padding-right: 0.25rem;\n}\n\n.header-navbar .navbar-header .nav-toggle {\n  flex: 0 0 auto;\n  margin-left: 0 !important;\n}\n\n.header-navbar .navbar-header .nav-toggle .modern-nav-toggle {\n  padding-left: 0.5rem !important;\n  padding-right: 0.35rem !important;\n}\n.badge-up {\n  top: 15px;\n  right: 10px;\n}\n\n.notification-item {\n  border-radius: 0.5rem;\n  transition: background-color 0.3s ease;\n \n  padding: 10px !important;\n  margin-bottom: 5px;  \n    border: 1px solid #ccc;\n}\n.notification-unread {\n  background-color: #f0f8ff; /* light blue for unread */\n  font-weight: 500;\n}\n.notification-read {\n  background-color: #f8f9fa; /* light gray for read */\n  color: #6c757d;\n}\n.notification-item:hover {\n  background-color: #e9ecef;\n}\n\n.notifcation-list {\n  overflow-y: auto;\n  height: calc(100vh - 72px) !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
